import BasePolicy from '@/policies/BasePolicy.js';

export default class IntegrationsPolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('can access integrations');
    }

    hasAdminAccess(user) {
        return user;
    }
}
